import {
  ICalculationGuestUpdate,
  IPaymentListItem,
} from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

import { ICalculationPaymentUpdate } from '../models/ICalculationPaymentUpdate';

interface IProps {
  calculationId: string;
  serviceId?: string;
  payload: any;
}

export const upsertCalculationService = ({
  calculationId,
  serviceId,
  payload,
}: IProps): Promise<any> => {
  if (serviceId === undefined) {
    return API.post(`api/accommodation/calculations/${calculationId}/services`, payload).then(
      response => response?.data,
    );
  }

  return API.put(`api/accommodation/calculations/services/${serviceId}`, payload).then(
    response => response?.data,
  );
};
